import {EntitySummary} from 'constants/UserConstants';
import {Institution} from 'institutions/InstitutionConstants';
import {UserSearchType, SearchResponse} from 'ui-library/entity-input/EntityInputWithSearch';
import * as net from 'util/Net';

interface SearchQueryParams {
  q: string;
  includeOrgs?: boolean;
  includeTeams?: boolean;
  includeBenchlingApps?: boolean;
  includeAgents?: boolean;
  userSearchType?: UserSearchType;
}

interface BulkGetEntitySummaryByHandleResponse {
  [key: string]: EntitySummary;
}

export function search(queryParams: SearchQueryParams): JQueryPromise<SearchResponse> {
  return net.getJSON('/1/api/entities/search', queryParams);
}

export function setInstitution(
  entityId: string,
  institutionUrlIdentifier: string
): JQueryPromise<Institution> {
  return net.patchJSON({
    url: `/1/api/users/${entityId}/institution`,
    data: {
      urlIdentifier: institutionUrlIdentifier,
    },
  });
}

export function bulkGetEntitySummariesByHandle(
  handles: Array<string>,
  silentlyFilterOutNotFound: boolean = false
): Promise<BulkGetEntitySummaryByHandleResponse> {
  return net.postJSONPromise({
    url: '/1/api/entities:bulk-get-summaries-by-handle',
    data: {handles, silentlyFilterOutNotFound},
  });
}
